import { createRenderer } from 'fela'
import prefixer from 'fela-plugin-prefixer'
import fallbackValue from 'fela-plugin-fallback-value'
import unit from 'fela-plugin-unit'
import extend from 'fela-plugin-extend'
import lvha from 'fela-plugin-lvha'
import beautifier from 'fela-beautifier'

import { breakpoints } from '../constants/theme'

const mediaOrder = Object.keys(breakpoints).reverse().reduce((order, breakpoint) => {
  order.push('(min-width: ' + breakpoints[breakpoint] + 'px)')
  return order
}, [ ])

const config = {
  prettySelectors: true,
  plugins: [
    extend(),
    prefixer(),
    fallbackValue(),
    unit(),
    lvha()
  ],
  enhancers: [],
  mediaQueryOrder: mediaOrder
}

if (process.env.NODE_ENV !== 'production') {
  config.enhancers.push(beautifier())
}

export function initializeRenderer(renderer) {
  renderer.clear()

  renderer.renderStatic({
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    margin: 0,
    padding: 0,
  }, 'html,body,#react-mount')


  renderer.renderStatic({
    backgroundColor: '#16181C',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility',
  textRendering: 'geometricPrecision',
  fontSmooth: 'always'
  }, 'body')

  renderer.renderStatic({
    textDecoration: 'none',
    color: 'inherit'
  }, 'a')

  // globale Anpassung für mobile
  renderer.renderStatic({
    boxSizing: 'border-box',
    margin: '0',
    padding: '0',
    WebkitMarginBefore: 0,
    WebkitMarginAfter: 0,
    fontFamily: 'Istok Web',
    appearance: 'none',
    WebkitTapHighlightColor: 'transparent',
    outline: 'none'
  }, '*')

  // Flexbox default-reset für alle divs
  renderer.renderStatic({
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    flexBasis: 'auto',
    alignContent: 'flex-start',
  }, 'div')

  renderer.renderStatic({ opacity: 0.0 }, '.invisible')

  return renderer
}

const renderer = createRenderer(config)
export default renderer



// WEBPACK FOOTER //
// ../utils/renderer.js